const Lock = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <g clip-path="url(#clip0_1595_4274)">
        <path
          d="M15.7713 8.99796V5.77161C15.7713 2.58401 13.1873 0 10.0001 0C6.81256 0 4.22852 2.58401 4.22852 5.77161V8.99796M6.30975 8.99796V5.77161C6.30975 3.73646 7.96537 2.08128 10.0001 2.08128C12.0348 2.08128 13.69 3.7365 13.69 5.77161V8.99796"
          fill="#D3DAE0"
        />
        <path
          d="M10.3368 0.010039C10.2253 0.00363279 10.1132 0 10.0001 0C6.81256 0 4.22852 2.58401 4.22852 5.77161V8.99796H4.90183V5.77161C4.90183 2.69705 7.30592 0.184413 10.3368 0.010039Z"
          fill="#899EA8"
        />
        <path
          d="M10.6726 2.0813C10.5591 2.0813 10.4469 2.08673 10.3359 2.09681C12.2134 2.26743 13.6892 3.85 13.6892 5.77163V8.99798H14.3625V5.77163C14.3626 3.73652 12.7074 2.0813 10.6726 2.0813Z"
          fill="#899EA8"
        />
        <path d="M17.6821 8.99805H2.31836V20.0001H17.6821V8.99805Z" fill="#F79F00" />
        <path d="M3.66495 8.99805H2.31836V20.0001H3.66495V8.99805Z" fill="#E48900" />
        <path
          d="M11.653 13.4662C11.653 12.5534 10.9131 11.8135 10.0003 11.8135C9.08761 11.8135 8.34766 12.5534 8.34766 13.4662C8.34766 14.0948 8.69875 14.6415 9.21546 14.9208L8.94953 16.9551H11.0512L10.7853 14.9208C11.302 14.6415 11.653 14.0949 11.653 13.4662Z"
          fill="#3E3D4C"
        />
      </g>
      <defs>
        <clipPath id="clip0_1595_4274">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Lock;
